import { module } from 'angular';
import { react2angular } from 'react2angular';

import { ExecutionWindowActions } from './ExecutionWindowActions';

export const EXECUTION_WINDOW_ACTIONS_COMPONENT = 'spinnaker.core.pipeline.config.stages.executionWindowActions.component';
module(EXECUTION_WINDOW_ACTIONS_COMPONENT, [])
  .component('executionWindowActions', react2angular(ExecutionWindowActions, ['execution', 'stage', 'application']));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/pipeline/config/stages/executionWindows/executionWindowActions.component.ts